import jiangSwitch from './jiang-switch'

export default jiangSwitch